<script setup>
import { ref } from "vue";

defineProps({
  contract: {
    type: Object,
    required: true,
  },
});

const formRef = ref(null);

function ruleRequiredText(val) {
  return (val != null && String(val).trim() !== "") || "Campo obrigatório";
}

async function validateForm() {
  if (!formRef.value) {
    return false;
  }
  const ok = await formRef.value.validate();
  return Boolean(ok);
}

defineExpose({
  validateForm,
});
</script>

<template>
  <div class="q-pa-md">
    <div class="title-page">NAP lotada (PE1 - COR)</div>
    <q-form ref="formRef" greedy @submit.prevent>
      <div class="col-12">
        <label for="customerName">Nome do cliente (titular)</label>
        <q-input
          id="customerName"
          class="col-4 q-mt-sm"
          v-model="contract.occurrenceAddress.customerName"
          placeholder="Digite aqui"
          bg-color="white"
          color="red-9"
          dense
          outlined
          maxlength="15"
          :rules="[ruleRequiredText]"
        />
      </div>
      <div class="col-12">
        <label for="napCustomer">NAP do cliente</label>
        <q-input
          id="napCustomer"
          class="col-4 q-mt-sm"
          v-model="contract.napCustomer"
          placeholder="Digite aqui"
          bg-color="white"
          color="red-9"
          dense
          outlined
          maxlength="15"
          :rules="[ruleRequiredText]"
        />
      </div>
      <div class="col-12">
        <label for="napInstallation">NAP de instalação</label>
        <q-input
          id="napInstallation"
          class="col-4 q-mt-sm"
          v-model="contract.napInstallation"
          placeholder="Digite aqui"
          bg-color="white"
          color="red-9"
          dense
          outlined
          maxlength="15"
          :rules="[ruleRequiredText]"
        />
      </div>
    </q-form>
  </div>
</template>

<style lang="scss" scoped>
.title-page {
  font-size: 1.25rem;
  font-weight: 700;
  color: red;
  margin: 0;
  margin-bottom: 1rem;
}
</style>
